// Internal modules
import { logger } from '@/lib/logger';
import { camelToSnakeCase } from '@/lib/utils';

export const logBillingTermLinkClickToFpti = (linkName: string): void => {
  const snakedLinkName = camelToSnakeCase(linkName);
  const eventName = `prepare_${snakedLinkName}_terms`;

  logger.fpti(eventName, {
    state_name: 'signup',
    transition_name: eventName,
  });
};
